"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _virtualStreamEvent = require("./virtualStreamEvent");
Object.keys(_virtualStreamEvent).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _virtualStreamEvent[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _virtualStreamEvent[key];
    }
  });
});